import { useNavigate } from "react-router-dom";

export const formatName = (rev, user, isApprover) => {
    if (rev.is_maintained_outside_system) {
      return "MAINTAINED OUTSIDE OF SYSTEM";
    } else {
      if (isApprover) {
        return user.map((u) => `${u.first_name} ${u.last_name}`).join(", ");
      } else {
        return user ? `${user.first_name} ${user.last_name}` : "-";
      }
    }
};

export const useRedirectToRevision = () => {
  const navigate = useNavigate();

  return (revData) => {
    const common1 = `${revData.type_name}/${revData.part_number}/${revData.procedureRevisionId}`;
    const common2 = `${revData.type_name}/${revData.part_number}/no-description`;
    // API / getCurrentStatus may use any casing; match case-insensitively
    const statusKey = String(revData.status ?? "")
      .trim()
      .toLowerCase();
    let url = "";
    switch (statusKey) {
      case "not submitted":
        url = `/revision-submission/${revData.partId}/${revData.revision}/${common1}/no-description`;
        break;
      case "change requested":
        url = `/revision-submission/${revData.partId}/${revData.revision}/${common1}/no-description`;
        break;
      case "submitted for approval":
        url = `/approve-revision/${revData.partId}/${revData.revision}/${common1}/no-description`;
        break;
      case "approved":
        url = `/release-revision/${revData.partId}/${revData.revision}/${common1}/no-description`;
        break;
      case "released":
        url = `/released-revision/${revData.partId}/${revData.revision}/${common2}/${revData.procedureRevisionId}`;
        break;
      case "rejected":
        url = `/rejected-revision/${revData.partId}/${revData.revision}/${common2}/Rejected/${revData.procedureRevisionId}`;
        break;
      case "archived":
        url = `/archived-revision/${revData.partId}/${revData.revision}/${common2}/Archived/${revData.procedureRevisionId}`;
        break;
      default:
        break;
    }

    if (url.length) {
      const navState = { status: revData.status };
      if (typeof revData.isViewMode === "boolean") {
        navState.isViewMode = revData.isViewMode;
      }
      navigate(url, { state: navState });
    } else {
    }
  };
};

export const getCurrentStatus = (rev) =>{
  let currentStatus =  rev?.status_changes?.find((sc) => sc.is_latest)?.status_changed_to || "-"
  if(currentStatus==="Approved"){
    let pendingApprovers = rev?.required_by?.filter(s=>s.purpose === "Approve").filter(s=>s.is_open);
    if(pendingApprovers && pendingApprovers.length){
      currentStatus = "Submitted For Approval"
    }
  }

  return currentStatus
}